import {handleActions} from 'redux-actions';

import {SET_EMAIL} from '/redux/action/auth.action';
import {withPayload} from '/util/reducer.util';

import setEmail from './auth/setEmail';

const initialState = {
  credentials: {},
};

export default handleActions(
  {
    [SET_EMAIL]: withPayload(setEmail),
  },
  initialState,
);
